<template>
    <div>
        <v-textarea
                v-model="item"
                :label="label"
                :readonly="readonly"
                outlined
                auto-grow
                :type="type"
                :min="min"
                :max="max"
                :height="height"
                :color="color ? color : inputColor"
                :background-color="color ? `${color} lighten-5` : backgroundColor"
                :clearable="!(readonly || notClearable)"
                dense
                :disabled="disabled"
                :hint="hint"
                :persistent-hint="persistentHint"
                :placeholder="placeholder"
                :autofocus="autoFocus"
                :step="step"
                :suffix="suffix"
                :prefix="prefix"
                hide-details="auto"
                :rules="rules"
                @input="input"
                @focus="$emit('focus')"
                @blur="$emit('blur')"
        ></v-textarea>

        <input type="hidden"/>
    </div>
</template>


<script>
import useSharedData from "@/use/SharedData";
import {ref, watch} from "vue";

export default {
    name: "WSimpleTextArea",
    props: {
        value: [Number, String],
        label: String,
        color: String,
        disabled: Boolean,
        autoFocus: Boolean,
        readonly: Boolean,
        notClearable: Boolean,
        rules: Array,
        type: String,
        min: String,
        max: String,
        hint: String,
        persistentHint: Boolean,
        placeholder: String,
        step: String,
        suffix: String,
        prefix: String,
        height: Number,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const item = ref(null);


        watch(() => props.value, () => {
            if (props.value !== null && props.value !== undefined)
                item.value = props.value;
        }, {immediate: true});


        function input(value) {
            emit('input', value);
        }

        return {
            loading,
            inputColor,
            backgroundColor,
            item,
            input,
        }
    },
};
</script>